import React from 'react';
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    footy: {
      backgroundImage: "url(./footer-form-bg.png)",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
      padding: "3rem",
    },
  
  }));

function Footer() {
  const classes = useStyles();
  return (
    <footer>
      <div className={classes.footy}>
       <p>Copyright RD</p>
      </div>
    </footer>
  );
}

export default Footer;